import { getVisits, getVisitsNew } from '@/api/workPlace/visits'
import { computed, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { visitType, TagType } from './config'
export default function (props) {
  const store = useStore()
  // const ucPatientId = computed(() => store.state.workOrder.workOrderGroupInfo.patientInfo.ucUserId)
  const ucPatientId = computed(() => {
    return (
      props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
    )
  })
  // 查询条件
  const queryParam = reactive({
    planStatus: 1,
    planType: 0 // 随访类型
  })
  // 随访数据
  const visits = reactive({
    loading: false,
    data: [],
    // 分页器
    pagination: {
      current: 1,
      pageSize: 10,
      showQuickJumper: true,
      showSizeChanger: true,
      total: 100,
      showTotal: () => {}
    },
    // 详情信息
    detail: {
      show: false,
      id: '0',
      serialNumber: '',
      recordType: 'visit'
    },
    // 判断随访新老数据
    visitPageType: null
  })
  // 获取数据
  function getData() {
    visits.loading = true
    const { planStatus = null, planType = 0 } = queryParam
    // 当是平台是区别用药计划和随访
    if (planType === visitType[0].value) {
      visits.visitPageType = planStatus
    } else {
      visits.visitPageType = null
    }
    const params = {
      ucPatientId: ucPatientId.value,
      pageNo: visits.pagination.current,
      pageSize: visits.pagination.pageSize,
      ...queryParam
    }
    if (planType === 0) {
      params.planStatus = null
    }
    const api =
      visits.visitPageType === TagType['medication'] ? getVisitsNew(params) : getVisits(params)
    api
      .then(res => {
        visits.data = res.list
        visits.pagination.current = res.currPage
        visits.pagination.total = res.totalCount
        visits.pagination.showTotal = () => `共${res.totalCount}条`
      })
      .finally(() => {
        visits.loading = false
      })
  }
  //改变当前页 和 改变页码值
  function onPageOrSize({ current = 1, pageSize = 10 }) {
    visits.pagination.pageSize = pageSize
    visits.pagination.current = current
    getData()
  }
  function onOperation(is = '', id = '0', serialNumber = '') {
    if (is === 'visit') {
      visits.detail.id = id
      visits.detail.serialNumber = serialNumber
    } else {
      visits.detail.id = id
      visits.detail.serialNumber = serialNumber
    }
    visits.detail.show = true
    visits.detail.recordType = is
  }
  onMounted(() => {
    getData()
  })
  watch(
    () => visits.detail.show,
    () => {
      getData()
    }
  )
  return { getData, onPageOrSize, onOperation, queryParam, visits }
}
